export interface PantryMediaFile {
  _id?: string
  id?: unknown
  id_select?: unknown
  name?: string
  src?: string
  public_url?: string
  thumbnail?: string
  srcset?: Record<string, string>
  alternative_text?: string
  alt?: string
  title?: string
  content_type?: string
  size?: number
  width?: number
  height?: number
  created_at?: string
  _created?: string
  resumable_upload_session?: string
  _badge?: string
  caption?: string
  asset_types?: string[]
  // Breadstack catalog image not copied yet (product picker only)
  spatula_doc_id?: string
  spatula_image_url?: string
  // Picker only: what the owner typed for this picked image, over its own values
  _edits?: PantryMediaFileEdits
}

export interface PantryMediaFileEdits {
  alternative_text?: string
  title?: string
  caption?: string
  name?: string
  asset_types?: string[]
}

export type GalleryPickerTab = 'library' | 'upload'

export const ASSET_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: 'product', label: 'Product Image' },
  { value: 'brand', label: 'Brand Logo' },
  { value: 'category', label: 'Category' },
  { value: 'banner', label: 'Banner' },
  { value: 'video', label: 'Video' },
]

export type SourceFilter = 'all' | 'breadstack' | 'tenant'
